import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';
import { http } from '@/pixel/index';
import LocalStorage, { LocalStorageKeys } from '@/components/commons/LocalStorage.js';
import Tracking from '@/components/commons/Tracking.js';
import { throttle } from '@/components/commons/MiniLodash';

let queue = [];
let attachedEventData = {};

export default class Chronicler {
  static throttledTrackQueuedEvents() {
    try {
      throttle(Chronicler.trackQueuedEvents, 1000)();
    } catch {}
  }

  /**
   * Attach additional data to send on each chronicler event.
   * eg. features, sessionId etc
   * */
  static async attach(params = {}) {
    attachedEventData = Object.assign({}, attachedEventData, params);
  }

  static async trackQueuedEvents() {
    if (import.meta.env.SSR) {
      return;
    }

    if (queue.length === 0) {
      return;
    }

    try {
      const events = [...queue];
      queue = [];
      await http.post(import.meta.env.VITE_CHRONICLE_ENDPOINT, events, null, { credentials: 'omit' }, false);
    } catch (e) {
      Tracking.sentryCaptureError(e);
    }
  }

  static async addQueuedEvent(eventData) {
    queue.push(eventData);
    Chronicler.throttledTrackQueuedEvents();
  }

  static async track(eventName, data = {}) {
    if (import.meta.env.SSR) {
      return;
    }

    const eventData = {
      event: eventName,
      identityId: UserService.getSessionId(),
      deviceId: LocalStorage.get(LocalStorageKeys.DEVICE_FINGERPRINT),
      metadata: {
        location: window.location.href,
        currency: LocationService.getCurrencyId(),
        browser: window.navigator.userAgent,
        browserRes: `${window.innerWidth || document.body.clientWidth}x${window.innerHeight || document.body.clientHeight}`,
        browserTime: Date.now(),
        screenRes: `${window.screen.width}x${window.screen.height}`,
        optOutTracking: Tracking.getTrackingOptOut()
      },
      data,
      ...attachedEventData,
    };

    Chronicler.addQueuedEvent(eventData);
  }
}
